import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  BG_CLOUDS,
  CLOUD_BIG_CYCLE,
  CLOUD_FIXED,
  CLOUD_SETS,
  CLOUD_SMALL_CYCLE,
  getCloudSetWidth,
  MAPLE_DECOS,
  RESULT_HERO_DECORATIONS,
  SHARED_HERO_DECORATIONS,
} from '../../../shared/config/decorations';
import {
  CloudInSet,
  CloudMover,
  CloudSetFixed,
  Decorations,
  Root,
} from './MenuPromoBackground.styles';
import { AnimatedWind } from './AnimatedWind';
import { AnimatedMaple } from './AnimatedMaple';

const { decorationMaple, decorationMapleBig } = SHARED_HERO_DECORATIONS;
const { cloudSmall, cloudBig } = BG_CLOUDS;

function CloudSetContent({ set }: { set: (typeof CLOUD_SETS)[number] }) {
  return (
    <>
      <CloudInSet
        src={cloudSmall}
        alt=""
        $topPercent={set.small.topPercent}
        $left={set.small.offsetX}
        $width={set.small.width}
        $opacity={set.small.opacity}
      />
      <CloudInSet
        src={cloudBig}
        alt=""
        $topPercent={set.big.topPercent}
        $left={set.big.offsetX}
        $width={set.big.width}
        $opacity={set.big.opacity}
      />
    </>
  );
}

/**
 * 투표·결과 공통 hero 배경.
 * 세트마다 작·큰 구름이 같이 출발하고, 큰 구름은 2.5배 느리게 이동한다.
 */
export function MenuPromoBackground() {
  const isResult = useLocation().pathname === '/result';
  const fixedSet = CLOUD_FIXED.set;
  const fixedWidth = getCloudSetWidth(fixedSet);

  return (
    <Root aria-hidden="true">
      <Decorations>
        <CloudSetFixed $width={fixedWidth} $left={CLOUD_FIXED.left}>
          <CloudSetContent set={fixedSet} />
        </CloudSetFixed>
        {CLOUD_SETS.map((set) => {
          const trackWidth = getCloudSetWidth(set);
          return (
            <React.Fragment key={set.id}>
              <CloudMover $width={trackWidth} $duration={CLOUD_SMALL_CYCLE} $delay={set.delay}>
                <CloudInSet
                  src={cloudSmall}
                  alt=""
                  $topPercent={set.small.topPercent}
                  $left={set.small.offsetX}
                  $width={set.small.width}
                  $opacity={set.small.opacity}
                />
              </CloudMover>
              <CloudMover $width={trackWidth} $duration={CLOUD_BIG_CYCLE} $delay={set.delay}>
                <CloudInSet
                  src={cloudBig}
                  alt=""
                  $topPercent={set.big.topPercent}
                  $left={set.big.offsetX}
                  $width={set.big.width}
                  $opacity={set.big.opacity}
                />
              </CloudMover>
            </React.Fragment>
          );
        })}
        <AnimatedWind />
        {isResult ? (
          <>
            <AnimatedMaple src={RESULT_HERO_DECORATIONS.decorationMapleAlt} config={MAPLE_DECOS.resultAlt} />
            <AnimatedMaple src={decorationMaple} config={MAPLE_DECOS.result} />
          </>
        ) : (
          <AnimatedMaple src={decorationMapleBig} config={MAPLE_DECOS.voteBig} />
        )}
      </Decorations>
    </Root>
  );
}
